<template>
  <div v-if="create || org._id">
    <h1>{{ create ? 'Create' : 'Edit' }} Organization</h1>
    <div>Fields marked with * are required.</div>
    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-12">
          <b-card>
            <b-form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-lg-6">
                  <b-form-group label="Name *" label-for="orgName">
                    <b-form-input id="orgName" v-model="org.name" placeholder="Name" type="text" :state="submitted && $v.org.name.$error ? false : null" />
                    <b-form-invalid-feedback v-if="submitted && !$v.org.name.required">Name is required</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Address 1 *" label-for="address1">
                    <b-form-input id="address1" v-model="org.address1" placeholder="Address 1" type="text" :state="submitted && $v.org.address1.$error ? false : null" />
                    <b-form-invalid-feedback v-if="submitted && !$v.org.address1.required">Address is required</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Address 2" label-for="address2">
                    <b-form-input id="address2" v-model="org.address2" placeholder="Address 2" type="text" />
                  </b-form-group>

                  <b-form-group label="City *" label-for="city">
                    <b-form-input id="city" v-model="org.city" placeholder="City" :state="submitted && $v.org.city.$error ? false : null" />
                    <b-form-invalid-feedback v-if="submitted && !$v.org.city.required">City is required</b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class="col-lg-6">
                  <b-form-group label="State *" label-for="state">
                    <b-form-select id="state" v-model="org.state" :options="stateOptions" />
                  </b-form-group>

                  <b-form-group label="Zip *" label-for="zip">
                    <b-form-input id="zip" v-model="org.zip" placeholder="Zip" :state="submitted && $v.org.zip.$error ? false : null" />
                    <b-form-invalid-feedback v-if="submitted && !$v.org.zip.required">City is required</b-form-invalid-feedback>
                  </b-form-group>
                  <TelephoneInput v-model="org.telephone" label="Telephone *" id="telephone" :submitted="submitted" />
                  <b-form-group label="Website" label-for="website">
                    <b-form-input id="website" v-model="org.website" placeholder="Website" />
                  </b-form-group>
                  <div class="text-right">
                    <b-button class="mr-2 btn-white" @click="onCancel()">Cancel</b-button>
                    <b-button type="submit" :disabled="submitted && $v.$invalid">{{ create ? 'Create' : 'Save' }}</b-button>
                  </div>
                  <b-form-invalid-feedback v-if="processErrors">{{ processErrors }}</b-form-invalid-feedback>
                </div>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import TelephoneInput from '@/components/TelephoneInput.vue';
import stateList from '../../assets/state-list.json';

export default {
  components: {
    TelephoneInput,
  },
  data() {
    return {
      org: {
        name: '',
        address1: '',
        address2: '',
        city: '',
        state: 'AL',
        zip: '',
        telephone: '',
        website: '',
      },
      submitted: false,
      stateOptions: stateList,
      processErrors: null,
    };
  },
  validations: {
    org: {
      name: {
        required,
      },
      address1: {
        required,
      },
      city: {
        required,
      },
      zip: {
        required,
      },
    },
  },
  props: {
    orgId: String,
    create: Boolean,
  },
  async created() {
    if (!this.create) {
      let org = this.$store.getters['organizations/getOrgById'](this.orgId);
      if (!org) {
        await this.$store.dispatch('organizations/getOrg', this.orgId);
        org = this.$store.getters['organizations/getOrgById'](this.orgId);
      }
      this.org = { ...this.org, ...org };
      if (this.org.state.length > 2) {
        this.org.state = this.stateOptions.find((s) => s.text === this.org.state).value;
      }
    }
  },
  methods: {
    async onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const url = this.create ? `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/` : `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${this.orgId}`;
      try {
        const response = await axios.post(url, this.org);
        if (response.data.errmsg) {
          this.$bvToast.toast(JSON.stringify(response.data.errmsg), {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: false,
          });
        } else {
          this.$store.commit('organizations/updateOrg', this.org);
          this.$store.commit('auth/updateUserOrg', this.org);
          this.$router.go(-1);
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: false,
        });
      }
    },
    async onCancel() {
      if (!this.create) {
        await this.$store.dispatch('organizations/updateLocalOrg', this.orgId);
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.card {
  border: none;
}
</style>
